import * as go from 'gojs';

const $ = go.GraphObject.make;
const KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);

go.Shape.defineFigureGenerator("Actor", function(shape, w, h) {
    var geo = new go.Geometry();
    var fig = new go.PathFigure(0, 0, false);
    geo.add(fig);

    var fig2 = new go.PathFigure(.335 * w, (1 - .555) * h, true);
    geo.add(fig2);
    // Shirt
    fig2.add(new go.PathSegment(go.PathSegment.Line, .335 * w, (1 - .405) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, (1 - .335) * w, (1 - .405) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, (1 - .335) * w, (1 - .555) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, w, .68 * h, (1 - .12) * w, .46 * h,
        (1 - .02) * w, .54 * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, w, h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, 0, h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, 0, .68 * h));
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, .335 * w, (1 - .555) * h, .02 * w, .54 * h,
        .12 * w, .46 * h));
    // Start of neck
    fig2.add(new go.PathSegment(go.PathSegment.Line, .365 * w, (1 - .595) * h));
    var radiushead = .5 - .285;
    var centerx = .5;
    var centery = radiushead;
    var alpha2 = Math.PI / 4;
    var KAPPA = ((4 * (1 - Math.cos(alpha2))) / (3 * Math.sin(alpha2)));
    var cpOffset = KAPPA * .5;
    var radiusw = radiushead;
    var radiush = radiushead;
    var offsetw = KAPPA * radiusw;
    var offseth = KAPPA * radiush;
    // Circle (head)
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, (centerx - radiusw) * w, centery * h, (centerx - ((offsetw + radiusw) / 2)) * w, (centery + ((radiush + offseth) / 2)) * h,
        (centerx - radiusw) * w, (centery + offseth) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, centerx * w, (centery - radiush) * h, (centerx - radiusw) * w, (centery - offseth) * h,
        (centerx - offsetw) * w, (centery - radiush) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, (centerx + radiusw) * w, centery * h, (centerx + offsetw) * w, (centery - radiush) * h,
        (centerx + radiusw) * w, (centery - offseth) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Bezier, (1 - .365) * w, (1 - .595) * h, (centerx + radiusw) * w, (centery + offseth) * h,
        (centerx + ((offsetw + radiusw) / 2)) * w, (centery + ((radiush + offseth) / 2)) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, (1 - .365) * w, (1 - .595) * h));
    // Neckline
    fig2.add(new go.PathSegment(go.PathSegment.Line, (1 - .335) * w, (1 - .555) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, (1 - .335) * w, (1 - .405) * h));
    fig2.add(new go.PathSegment(go.PathSegment.Line, .335 * w, (1 - .405) * h));
    var fig3 = new go.PathFigure(.2 * w, h, false);
    geo.add(fig3);
    // Arm lines
    fig3.add(new go.PathSegment(go.PathSegment.Line, .2 * w, .8 * h));
    var fig4 = new go.PathFigure(.8 * w, h, false);
    geo.add(fig4);
    fig4.add(new go.PathSegment(go.PathSegment.Line, .8 * w, .8 * h));
    return geo;
});

export const StaticDiagramAccess2Sign = {
    'public': '',
    // 'private': '-',
    'static': '+',
};

const StaticDiagramPropertyTemplate = $(go.Panel, 'Horizontal',
    // visibility
    $(go.TextBlock, {isMultiline: false, editable: false}, new go.Binding('text', 'access', v => StaticDiagramAccess2Sign[v]), new go.Binding('visible', 'access', v => v !== 'public')),
    // property name
    $(go.TextBlock, {isMultiline: false, editable: true}, new go.Binding('text', 'property').makeTwoWay()),
    $(go.TextBlock, {text: ':', font: 'bold .8rem "Nunito",sans-serif', margin: new go.Margin(0,2,0,2)}),
    $(go.TextBlock, {isMultiline: false, editable: true, font: 'italic bold .7rem "Nunito",sans-serif'}, new go.Binding('text', 'type').makeTwoWay())
);

export const StaticDiagramObjectNode = $(go.Node, 'Auto', {rotatable: true, locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    new go.Binding('angle', 'agl').makeTwoWay(),
    $(go.Shape, 'RoundedRectangle', {portId: '', fromLinkable: true, toLinkable: true}, new go.Binding('fill', 'isDone', v => v ? 'white' : 'orange')),
    $(go.Panel, 'Table',
        $(go.RowColumnDefinition, {row: 1, separatorStroke: 'black' }), // , new go.Binding('separatorStroke', 'properties', v => v.length > 0 ? 'black':null).makeTwoWay()
        $(go.TextBlock, {row: 0, font: 'bold .8rem "Nunito",sans-serif', isMultiline: false, editable: true, margin: new go.Margin(2, 0, 2, 0)}, new go.Binding('text', 'key').makeTwoWay()),
        $(go.Panel, 'Vertical', {}, new go.Binding('itemArray', 'properties'), {
            row: 1, margin: new go.Margin(2, 2, 2, 2), itemTemplate: StaticDiagramPropertyTemplate
        })
    )
);

export const ERLinkMap = {
    'one2many': {from: 'BackwardLineFork', to: 'LineFork'},
    'zero2many': {from: 'BackwardCircleFork', to: 'CircleFork'},
    'zero2one': {from: 'LineCircle', to: 'CircleLine'},
    'one2one': {from: 'DoubleLine', to: 'DoubleLine'}
};

export const StaticDiagramLink = $(go.Link,
    { routing: go.Link.Normal },
    $(go.Shape, {strokeWidth: 2}),
    $(go.Shape, new go.Binding('fromArrow', 'fromT', v => ERLinkMap[v].from), {fill: 'white', scale: 1.7, segmentIndex: 0, segmentOffset: new go.Point(3, 0)}),
    $(go.Shape, new go.Binding('toArrow', 'toT', v => ERLinkMap[v].to), {fill: 'white', scale: 1.7, segmentIndex: -1, segmentOffset: new go.Point(-3, 0)})
);

export const TmpStaticDiagramLink = $(go.Link,
    { routing: go.Link.Normal, curve: go.Link.Bezier, layerName: 'Tool' },
    $(go.Shape, {strokeWidth: 2}),
    $(go.Shape, {fromArrow: 'BackwardCircleFork', fill: 'white', scale: 1.7, segmentIndex: 0, segmentOffset: new go.Point(3, 0)}),
    $(go.Shape, {toArrow: 'CircleFork', fill: 'white', scale: 1.7, segmentIndex: -1, segmentOffset: new go.Point(-3, 0)})
);

export const DynamicDiagramRoleNode = $(go.Node, 'Auto', {rotatable: true, locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    new go.Binding('angle', 'agl').makeTwoWay(),
    $(go.Panel, 'Table', {},
        $(go.Shape, {row: 0, column: 0, figure: 'Actor', fill: 'white', scale: .27, strokeWidth: 8, portId: '', fromLinkable: true, toLinkable: true}),
        $(go.TextBlock, {row: 1, column: 0, font: 'bold .8rem "Nunito",sans-serif', isMultiline: false, editable: true}, new go.Binding('text', 'key').makeTwoWay())
    )
);

export const DynamicDiagramActionNode = $(go.Node, 'Auto', {rotatable: true, locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    new go.Binding('angle', 'agl').makeTwoWay(),
    $(go.Shape, 'Ellipse', {portId: '', fromLinkable: true, toLinkable: true},
        new go.Binding('fill', 'isDone', v => v ? 'white' : 'orange')),
    $(go.TextBlock, { margin:5, font: '.8rem "Nunito",sans-serif', isMultiline: false, editable: true}, new go.Binding('text', 'key').makeTwoWay())
);

export const DynamicDiagramActivityNode = $(go.Node, 'Auto', {rotatable: true, locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    new go.Binding('angle', 'agl').makeTwoWay(),
    $(go.Shape, 'RoundedRectangle', {portId: '', fromLinkable: true, toLinkable: true},
        new go.Binding('fill', 'isDone', v => v ? 'white' : 'orange')),
    $(go.TextBlock, { margin:8, font: '.7rem "Nunito",sans-serif', isMultiline: true, editable: true}, new go.Binding('text', 'key').makeTwoWay())
);

export const DynamicDiagramStartNode = $(go.Node, 'Auto', {locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    $(go.Panel, 'Vertical',
        $(go.Shape, 'Ellipse', {width: 14, height: 14, portId: '', fromLinkable: true, toLinkable: true}),
        $(go.TextBlock, {isMultiline: false, editable: true}, new go.Binding('text', 'key').makeTwoWay())
    )
);

export const DynamicDiagramEndNode = $(go.Node, 'Auto', {locationSpot: go.Spot.Center},
    new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
    $(go.Panel, 'Vertical',
        $(go.Shape, 'Ellipse', {width: 14, height: 14, fill: 'white', strokeWidth: 6, portId: '', fromLinkable: true, toLinkable: true}),
        $(go.TextBlock, {isMultiline: false, editable: true}, new go.Binding('text', 'key').makeTwoWay())
    )
);

export const DynamicDiagramLink = $(go.Link,
    { routing: go.Link.Normal, curve: go.Link.Bezier, fromEndSegmentLength: 40, toEndSegmentLength: 50},
    $(go.Shape, {strokeWidth: 2}, new go.Binding('strokeDashArray', '', v => {
        if (v.fromNode.data.category === 'action' && v.toNode.data.category === 'start') {
            return [5, 2];
        }
        return null;
    }).ofObject()),
    $(go.Shape, {fromArrow: 'BackwardTriangle', fill: 'white'}, new go.Binding('visible', '', v => {
        return v.fromNode.data.category === 'actor' && v.toNode.data.category === 'actor';
    }).ofObject()),
    $(go.Shape, {toArrow: 'Triangle'}, new go.Binding('visible', '', v => {
        return ((v.fromNode.data.category === 'actor' || v.fromNode.data.category === 'action') && v.toNode.data.category === 'action') ||
            v.toNode.data.category === 'activity' ||
            v.toNode.data.category === 'end'
            ;
    }).ofObject())
);

export const TmpDynamicDiagramLink = $(go.Link,
    { routing: go.Link.Normal, curve: go.Link.Bezier, layerName: 'Tool' },
    $(go.Shape, {strokeWidth: 1, strokeDashArray: [5, 2]}),
);
